import Layout from '@layout/Index'

export const orderReviewAssessment = [
  {
    path: '/order-review-assessment',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'questionnaire-config',
      },
      {
        path: 'questionnaire-config',
        component: () => import(/* webpackChunkName: "order-review-assessment-questionnaire-config" */ '@core/pages/CommonPage.vue'),
        name: '问卷配置',
        meta: {
          title: '问卷配置',
        },
      },
      {
        path: 'target-setting',
        component: () => import(/* webpackChunkName: "order-review-assessment-target-setting" */ './pages/TargetProjectSettingTable.vue'),
        name: '目标项目设定',
        meta: {
          title: '目标项目设定',
        },
      },
      {
        path: 'target-setting/detail/:projectId',
        component: () => import(/* webpackChunkName: "order-review-assessment-target-setting-detail" */ './pages/TargetSettingTable.vue'),
        name: '目标设置',
        meta: {
          title: '目标设置',
        },
      },
      {
        path: 'keyin-exception-feedback',
        component: () => import(/* webpackChunkName: "order-review-assessment-keyin-exception-feedback" */ './pages/KeyinExceptionFeedback.vue'),
        name: 'KeyIn异常工单反馈',
        meta: {
          title: 'KeyIn异常工单反馈',
        },
      },
    ],
  },
]




// WEBPACK FOOTER //
// ./src/views/order-review-target-management/order-review-assessment.route.js